// web/src/services/operatorService.js
import {
  collection,
  doc,
  addDoc,
  updateDoc,
  deleteDoc,
  getDocs,
  getDoc,
  serverTimestamp,
  setDoc,
} from "firebase/firestore";

import { db } from "../firebase/firebase";
import {
  createUserWithEmailAndPassword,
  deleteUser,
} from "firebase/auth";
import { auth } from "../firebase/firebase";

/* ============================================================
   COLEÇÃO NO FIRESTORE
============================================================ */
const OPERATORS_COLLECTION = "operators";

/* ============================================================
   1) CRIAR ATENDENTE (COM OPÇÃO DE CRIAR AUTH OU NÃO)
============================================================ */

export async function createOperator(data) {
  const { name, email, password, role, status } = data;

  let authUser = null;

  try {
    /* ----------------------------------------------------
       OPÇÃO 1 — Criar conta Firebase Auth
       (caso atendente tenha login próprio no painel)
    ---------------------------------------------------- */
    try {
      authUser = await createUserWithEmailAndPassword(auth, email, password);
    } catch (authErr) {
      console.warn("Auth não criado. Continuando apenas Firestore.");
    }

    /* ----------------------------------------------------
       Dados que serão salvos no Firestore
    ---------------------------------------------------- */
    const operatorData = {
      name,
      email,
      role: role || "attendant",
      status: status || "offline",
      createdAt: serverTimestamp(),
      authUid: authUser ? authUser.user.uid : null,
    };

    /* ----------------------------------------------------
       Salvar na coleção "operators"
    ---------------------------------------------------- */
    const docRef = await addDoc(
      collection(db, OPERATORS_COLLECTION),
      operatorData
    );

    return {
      id: docRef.id,
      ...operatorData,
    };
  } catch (err) {
    console.error("Erro ao criar atendente:", err);
    throw err;
  }
}

/* ============================================================
   2) BUSCAR TODOS OS ATENDENTES
============================================================ */

export async function getAllOperators() {
  const snap = await getDocs(collection(db, OPERATORS_COLLECTION));
  return snap.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
}

/* ============================================================
   3) BUSCAR ATENDENTE POR ID
============================================================ */

export async function getOperatorById(id) {
  const docRef = doc(db, OPERATORS_COLLECTION, id);
  const snap = await getDoc(docRef);

  if (!snap.exists()) return null;

  return {
    id: snap.id,
    ...snap.data(),
  };
}

/* ============================================================
   4) ATUALIZAR ATENDENTE
============================================================ */

export async function updateOperator(id, data) {
  const docRef = doc(db, OPERATORS_COLLECTION, id);
  await updateDoc(docRef, { ...data });
  return true;
}

/* ============================================================
   5) ATUALIZAR STATUS (online / offline / busy)
============================================================ */

export async function updateOperatorStatus(id, status) {
  const docRef = doc(db, OPERATORS_COLLECTION, id);
  await updateDoc(docRef, {
    status,
    lastStatusChange: serverTimestamp(),
  });
}

/* ============================================================
   6) EXCLUIR ATENDENTE (com remoção opcional no Auth)
============================================================ */

export async function deleteOperator(id, removeAuth = false) {
  const docRef = doc(db, OPERATORS_COLLECTION, id);
  const operatorData = await getOperatorById(id);

  // remover firestore
  await deleteDoc(docRef);

  // remover auth (opcional, só administradores deveriam fazer isso)
  if (removeAuth && operatorData?.authUid) {
    try {
      const user = await auth.getUser(operatorData.authUid);
      if (user) await deleteUser(user);
    } catch (err) {
      console.warn("Erro ao remover usuário do Auth:", err);
    }
  }

  return true;
}

/* ============================================================
   7) CRIAR OPERADOR COM ID PERSONALIZADO (exemplo)
============================================================ */

export async function createOperatorWithCustomId(id, data) {
  const docRef = doc(db, OPERATORS_COLLECTION, id);
  await setDoc(docRef, {
    ...data,
    createdAt: serverTimestamp(),
  });

  return { id, ...data };
}
